import { Injectable } from '@angular/core';
import { BrewersUnitOfWork } from 'app/core/data/client-unit-of-work';
import { AppInformationService } from '../app-information.service';
import { AuthService } from '../auth.service';
import { UtilityService } from './utility.service';

@Injectable()
export class EntitiesService {
    constructor(private uow: BrewersUnitOfWork, private auth: AuthService, private appInfo: AppInformationService, private utility: UtilityService) {}

}
